import React from 'react';
import NavDropdown from '../../navigation/NavDropdown';
import Navbar from '../../navigation/Navbar';
const ReportNavigation = ({ store }) => {
    const { section } = store;
    const sections = Array.from(document.querySelectorAll('.ReadReportContent__Section>h4'));
    function onScroll() {
        const HEADER_HEIGHT = 123;
        const onScreen = sections.find(heading => document.documentElement.scrollTop - heading.offsetTop < -HEADER_HEIGHT);
        store.section = onScreen
            ? onScreen.textContent
                ? onScreen.textContent
                : ''
            : '';
    }
    //useScroll(onScroll) //it does not work as intended, it duplicates the text content
    function onChange(selected) {
        var _a, _b;
        (_b = (_a = sections
            .find(heading => heading.textContent === selected)) === null || _a === void 0 ? void 0 : _a.parentElement // Parent has padding-top equal to this element's height
        ) === null || _b === void 0 ? void 0 : _b.scrollIntoView({ behavior: 'smooth', block: 'start' });
    }
    const selectProps = {
        options: sections.map(s => s.textContent),
        onChange,
        value: section
    };
    return (React.createElement(React.Fragment, null,
        React.createElement(Navbar, Object.assign({}, selectProps, { options: selectProps.options.slice(1, -1) })),
        React.createElement(NavDropdown, Object.assign({}, selectProps)),
        " "));
};
export default ReportNavigation;
